import store from "../../../store";
import {SQFT_AREA_TYPE_PART_IDS, SQFT_GROUP} from "../constants";
import {getUrlSQFTHashParam} from "./sqftHelper";
import sqftConfig from "../components/canvas/store/sqftConfig";

export const getSQFTGroupFromUrl = () => {
  return getUrlSQFTHashParam("group")
}

/**
 * Is SQFT in Area Group TYPE
 */
export const getIsSFTAreaGroup = () => {
  const isSFTAreaGroupInUrl = getSQFTGroupFromUrl();
  const {sqftState} = store.getState();
  const {sqftFromFeature} = sqftState;

  return isSFTAreaGroupInUrl || sqftFromFeature && (Object.keys(SQFT_AREA_TYPE_PART_IDS).includes(sqftFromFeature.cartFeature.partId));
}

/**
 * Is SQFT in Cabinets Group TYPE
 */
export const isSFTCabinetsGroup = () => {
  const isCabinetGroupInURL = sqftConfig.isCabinetGroupInURL();
  const {sqftState} = store.getState();
  const {SQFTGroup} = sqftState;

  return isCabinetGroupInURL || SQFTGroup === SQFT_GROUP.cabinets;
}

/**
 * Is SQFT Group Type
 */
export const getSQFTGroup = () => {
  const isSFTAreaGroupInUrl = getSQFTGroupFromUrl();
  const {sqftState} = store.getState();
  const {sqftFromFeature} = sqftState;

  if (isSFTAreaGroupInUrl) {
    return isSFTAreaGroupInUrl
  }

  if (sqftFromFeature) {
    return sqftFromFeature.cartFeature.partId;
  }

  return false
}
